import { render } from "./configDiscountComponent.vue?vue&type=template&id=3dcd0fa2"
import script from "./configDiscountComponent.vue?vue&type=script&lang=js"
export * from "./configDiscountComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__